export default __webpack_public_path__ + "static/media/calendar-icon-subscribe.5f094a42.svg";